import React from 'react'


const CallBackCard = ({details}) => {
       
        const fullTimestamp = details.modified;
        const dateTime = new Date(fullTimestamp);
        const year = dateTime.getFullYear();
        
        const monthNames = [
          "Jan", "Feb", "Mar", "Apr", "May", "Jun",
          "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"
        ];
        const monthIndex = dateTime.getMonth();
        const month = monthNames[monthIndex];
        
        const day = String(dateTime.getDate()).padStart(2, '0');
        const formattedDate = `${month} ${day}th, ${year}`;


  return (
   <>
   <div className='CallBack-card'>
    <div className='name-request'>
        <p className='name'>{details.name}</p>
        <span className='request-date'>Requested on {" "} {formattedDate} </span>

    </div>
    <div className='contact-box' style={{marginLeft:details?.location?"5%":"5%"}}>
            <p >Contact</p>
            <input  type="text" className='number' value={details.mobile}  readOnly={true}></input>
    </div>

  
        
            
            
  

   
        <div className='location-box' style={{marginLeft:details?.location?"5%":"5%"}}>
        <p >Email</p>
  <div className={`scroll-wrapper ${details.email.length > 35 ? 'show-scroll' : ''}`}>
    <div className='location'>{details.email}</div>
  </div>
</div>


    {details?.location ? (
        <div className='location-box'>
  <p>Location</p>
  <div className={`scroll-wrapper ${details.location.length > 35 ? 'show-scroll' : ''}`}>
    <div className='location'>{details.location}</div>
  </div>
</div>

) : null}


   </div>
   </>
  )
}

export default CallBackCard